import template from './water.jade';
import suburbanWaterType from '../../../enums/suburban-water-type';

export default angular.module('cian.addForm.commonWater', []).directive('cianAfCommonWater', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.suburbanWaterTypeOptions = suburbanWaterType;

      const isUnknownType = typeof this.ad.hasWater === 'undefined' || this.ad.hasWater;

      if (isUnknownType && this.ad.water?.suburbanWaterType) {
        this.value = this.ad.water.suburbanWaterType;
      } else if (this.ad.hasWater === false && !this.ad.water?.suburbanWaterType) {
        this.value = 'no';
      }

      const updateWaterValue = ({ waterType, hasWater }) => {
        const water = waterType ? { ...this.ad.water, suburbanWaterType: waterType } : undefined;

        this.ad = {
          ...this.ad,
          water,
          hasWater,
        };
      };

      this.handleChange = () => {
        const waterValue =
          this.value === 'no'
            ? { hasWater: false }
            : { waterType: this.value, hasWater: this.ad.hasWater || undefined };

        updateWaterValue(waterValue);
      };
    },
  ],
  controllerAs: 'water',
  template,
})).name;
